import { Box, FormControl, InputLabel, MenuItem, Select, Tab, Tabs } from "@mui/material";
import React, { useState } from 'react';
import VideoModal from '../components/VideoModal';
import CustomerCards from './CustomerCards';
import EmployeeCards from './EmployeeCards';
import LiveDemosCards from './LiveDemosCards';
import { cards, liveDemoCards } from './IamData';
import { MdArrowForward } from "react-icons/md";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box 
            sx={{ 
                display: value === index ? 'block' : 'none',
                p: 0,
            }}
          >
            {children}
          </Box>
        )}
      </div>
    );
}
  
function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const IamPage = () => {

    const [value, setValue] = useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const [searchResults, setSearchResults] = useState([])
    const [searchValue, setSearchValue] = useState("")

    const [open, setOpen] = useState(false);    
    const [demoData, setDemoData] = useState();
    const [selected, setSelected] = useState("")

    const handleOpen = (videoData) => {
        setDemoData(videoData)
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    const url = new URL(window.location.href);

    const filterCards = (cards, searchValue) => {
        if (!searchValue.trim()) return [];
    
        return cards.filter(card => 
            card.text.toLowerCase().includes(searchValue.toLowerCase()) ||
            (card.tags && card.tags.some(tag => tag.toLowerCase().includes(searchValue.toLowerCase())))
        );
    };

    const handleSearchChange = (event) => {
        const value = event.target.value;
        setSearchValue(value);
    
        if (!value.trim()) {
            setSearchResults([]);
            return;
        }
    
        const filteredCards = filterCards(cards, value)
        setSearchResults(filteredCards);
    };

    const filteredCards = searchValue.trim() ? filterCards(cards, searchValue) : [];

    const handleSelect = (event) => {
        const value = event.target.value;
        setSelected(value)
    }


  return (
    <>
        <div className="backButton d-flex align-items-center mx-2 my-2" onClick={()=>window.location.href = `${url.origin}/demo`}>
            <span className="material-symbols-rounded text-dark" >
                keyboard_arrow_left
            </span>
            <p className="mb-0">Back to main page</p>
        </div>
        <div className='w-100 bg-light px-5'>
            <div className='row justify-content-between align-items-center w-100 py-2 ps-sm-4 ps-0'>
                <div className='col-md-6 col-sm-6 col-12'>
                    <h4 className='text-start mt-2 h-auto lh-base text-secondary-emphasis fw-bold mt-2 mt-md-0'>IAM: The Modern Identity Platform</h4>
                </div>
                <div className='col-md-4 col-sm-6 col-12'>
                    <input class="form-control p-3" placeholder="Search" onChange={(e) => handleSearchChange(e)}  />
                </div>
            </div>
        </div>
        <div className='px-sm-4 px-0 pt-0 d-flex flex-column h-100 flex-grow-1'>
            {searchValue?.length === 0 && 
                <div className='mt-2 px-0 px-sm-5 row mx-sm-0 mx-4 d-flex flex-column h-100 flex-1'>
                    <div className="m-0 p-0">
                        <div className='pt-2 row gx-5 gy-3'>
                            <div className="col-lg-9 col-md-8 col-sm-7 col-12">
                                <Tabs 
                                    value={value} 
                                    orientation='horizontal'
                                    onChange={handleChange}
                                    TabIndicatorProps={{
                                        style: {
                                            backgroundColor:'transparent',
                                            height: "55px",
                                            borderBottom:'3px solid #EB5424',
                                        },
                                    }} 
                                    aria-label="basic tabs example"
                                >
                                    <Tab 
                                        className='font-14'
                                        label= "Employee"
                                        disableRipple
                                        sx={{
                                            color:'#gray', 
                                            fontFamily: 'inherit',
                                            textTransform: 'capitalize', 
                                            fontWeight:600,
                                            '&.Mui-selected': {
                                                color: '#EB5424',
                                            },
                                        }} 
                                        {...a11yProps(0)}
                                    />
                                    <Tab
                                        className='font-14'
                                        label= "Customer"
                                        disableRipple
                                        sx={{
                                            color:'#gray', 
                                            fontFamily: 'inherit',
                                            textTransform: 'capitalize', 
                                            fontWeight:600  ,
                                            '&.Mui-selected': {
                                                color: '#EB5424',
                                            },
                                        }} 
                                        {...a11yProps(1)}
                                    />
                                    <Tab
                                        className='font-14'
                                        label= "Live Demos"
                                        disableRipple
                                        sx={{
                                            color:'#gray', 
                                            fontFamily: 'inherit',
                                            textTransform: 'capitalize', 
                                            fontWeight:600  ,
                                            '&.Mui-selected': {
                                                color: '#EB5424',
                                            },
                                        }} 
                                        {...a11yProps(2)}
                                    />
                                </Tabs>
                            </div>
                            {value === 0 &&
                                <div className="col-lg-3 col-md-4 col-sm-5 col-12 align-bottom">
                                    <select className="form-select" onChange={(event) => handleSelect(event)}>
                                        <option style={{fontSize:'14px'}} value="all">All</option>
                                        <option style={{fontSize:'14px'}} value="sso">SSO</option>
                                        <option style={{fontSize:'14px'}} value="mfa">MFA</option>
                                        <option style={{fontSize:'14px'}} value="adaptive">Adaptive</option>
                                        <option style={{fontSize:'14px'}} value="ulm">User Lifecycle Management</option>
                                    </select>
                                </div>
                            }
                        </div>
                    </div>
                    <div className='col mt-3 mx-sm-0 mx-4 ps-4 pe-0 mb-5 mb-sm-0 d-flex flex-column h-100 flex-1'>
                        <TabPanel value={value} index={0}>
                            <EmployeeCards selected={selected} cards={cards} />
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <CustomerCards selected={selected} cards={cards} />
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            <LiveDemosCards liveDemoCards={liveDemoCards} />
                        </TabPanel>
                    </div>
                </div>      
            }
            {searchValue?.trim() && searchResults?.length > 0 &&
                <div className='mt-5 px-0 pb-4 px-sm-5 overflow-auto' style={{ height: "calc( 100vh - 330px)"}} >
                    <div className="mx-sm-4">
                        <div className="row g-4">
                            {searchResults?.map((item, index) => (
                                <div key={index} className="col-sm-12 col-md-6 col-lg-4 col-xl-3 card-hover-wrapper">
                                    <div className="custom-shadow d-flex flex-column border rounded-4 px-4 py-4 align-items-start h-100" onClick={()=> handleOpen(item)} >
                                        <div className="d-flex align-items-center justify-content-center text-14 border rounded-3 mb-3">
                                            <div className="d-flex justify-content-center align-items-center m-2 rounded-circle" style={{height: "40px", width: "40px"}} >
                                                {item?.icon}
                                            </div>
                                        </div>
                                        <div className='d-flex flex-column'>
                                            <span style={{fontWeight:500, fontSize:'17px'}}>
                                                {item?.text}
                                            </span>
                                            <span className='font-14 fw-normal' style={{color:"#a7a7a7"}}>
                                                {item?.desc}
                                            </span>
                                        </div>
                                        <div className='watch-btn fw-medium' style={{color:"#EB5424"}}>
                                            Watch now <MdArrowForward />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {open &&
                        <VideoModal
                        open={open}
                        handleOpen={handleOpen}
                        handleClose={handleClose}
                        videoData={demoData}
                        />
                    }
                </div>
            }
        </div>
    </>
  )
}
